import { render } from "./wallet.vue?vue&type=template&id=c4359c08"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"

import "./wallet.vue?vue&type=style&index=0&id=c4359c08&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__